import { render, staticRenderFns } from "./modifyParamList.vue?vue&type=template&id=f5d0fd4c&scoped=true"
import script from "./modifyParamList.vue?vue&type=script&lang=js"
export * from "./modifyParamList.vue?vue&type=script&lang=js"
import style0 from "./modifyParamList.vue?vue&type=style&index=0&id=f5d0fd4c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d0fd4c",
  null
  
)

export default component.exports